import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import ListRow from 'components/ListRow'
import NotificationImage from './Notification.Image'
import NotificationText from './Notification.Text'
import './index.scss'

class Notification extends React.Component {
  static Image = NotificationImage

  static Text = NotificationText

  static defaultProps = {
    isRead: false
  }

  static propTypes = {

    children: PropTypes.arrayOf(PropTypes.element).isRequired,
    isRead: PropTypes.bool,
    onClick: PropTypes.func.isRequired
  }

  render () {
    const className = classNames({
      notification: true,
      notification_border: !this.props.isRead
    })
    return (
      <div
        className={className}
        onClick={this.props.onClick}
      >
        <ListRow
          align={ListRow.ALIGN.CENTER}
          hasHover
        >
          {this.props.children}
        </ListRow>
      </div>
    )
  }
}

export default Notification
